export default __webpack_public_path__ + "papiekanki.613ce5a2.svg";